import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminSettings from "@/pages/admin/AdminSettings";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/settings")({
  head: () => adminHead("Settings | Admin", "Admin settings and configuration.", "/admin/settings"),
  component: () => (
    <ProtectedRoute>
      <AdminSettings />
    </ProtectedRoute>
  ),
});
